import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer">
        <div className="footer__left">
          <p>©2022 Oh My Plants</p>
        </div>
        <div className="footer__right">
          <p>Made by Robert Cabrera & María Gallego</p>
        </div>    
    </div>
  );
};

export default Footer;
